// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BUAsu","colMin":"styles_colMin__-C-UA"};